module.exports = "<div class=\"kd-item ui-card padding-md\">\r\n  <div class=\"item-section nobreak flex\">\r\n    <span class=\"typo-title\">{{$ctrl.item.nombre}}</span>\r\n  </div>\r\n  <div align=\"center\">\r\n    <span class=\"typo-body-2\">{{$ctrl.item.abono | currency}}</span>\r\n  </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/recursoshumanos/components/reportes/retencion/infonavit/item/template.html
// module id = 754
// module chunks = 0